// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XLVv","type":"styles_type__2HBzA","choices":"styles_choices__2wUtN"};